import { useState, lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import BetaBanner from "@/components/BetaBanner";
import WaitlistModal from "@/components/WaitlistModal";

const SearchDemo = lazy(() => import("@/components/SearchDemo"));
const Core4Section = lazy(() => import("@/components/Core4Section"));
const CTASection = lazy(() => import("@/components/CTASection"));

const SectionFallback = () => (
  <div className="py-24 flex items-center justify-center">
    <div className="h-8 w-8 border-2 border-primary/30 border-t-primary rounded-full animate-spin" />
  </div>
);

const Index = () => {
  const [showWaitlist, setShowWaitlist] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <BetaBanner />
      <Navbar onWaitlistClick={() => setShowWaitlist(true)} />
      <HeroSection onWaitlistClick={() => setShowWaitlist(true)} />
      <Suspense fallback={<SectionFallback />}>
        <SearchDemo onWaitlistClick={() => setShowWaitlist(true)} />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <Core4Section />
      </Suspense>
      <Suspense fallback={<SectionFallback />}>
        <CTASection onWaitlistClick={() => setShowWaitlist(true)} />
      </Suspense>
      <footer className="border-t border-border py-8">
        <div className="container text-center text-sm text-muted-foreground">
          © 2026 <a href="https://medgrowthpartners.net/" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-colors">MedGrowth Partners</a>. All rights reserved.
        </div>
      </footer>
      <WaitlistModal open={showWaitlist} onClose={() => setShowWaitlist(false)} />
    </div>
  );
};

export default Index;